angular.module('LeasePilot').filter('toLabel', function() {
  return function(input, index) {
    return !!input ? _.replace(input, '{#}', index || '') : '';
  };
});
